export const b2bRedemptionRevampContentMaxWidth = '1188px';
